/*
 * UserEdit Messages
 *
 * This contains all the text for the UserEdit component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.UserEdit.title',
    defaultMessage: 'Edit User',
  },
  saveButton: {
    id: 'app.containers.UserEdit.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'app.containers.UserEdit.saveSuccess',
    defaultMessage: 'User has been successfully updated.',
  },
  saveFailure: {
    id: 'app.containers.UserEdit.saveFailure',
    defaultMessage: 'Error. The user could not be updated.',
  },
  deleteButton: {
    id: 'app.containers.UserEdit.deleteButton',
    defaultMessage: 'Delete',
  },
  deleteSuccess: {
    id: 'app.containers.UserEdit.deleteSuccess',
    defaultMessage: 'User has been successfully deleted.',
  },
  deleteFailure: {
    id: 'app.containers.UserEdit.deleteFailure',
    defaultMessage: 'Error. The user could not be deleted.',
  },
  deleteConfirmTitle: {
    id: 'app.containers.UserEdit.deleteConfirmTitle',
    defaultMessage: 'Delete User?',
  },
  deleteConfirmText: {
    id: 'app.containers.UserEdit.deleteConfirmText',
    defaultMessage: 'Deleting a User will permanently remove him.',
  },
  deleteConfirmDelete: {
    id: 'app.containers.UserEdit.deleteConfirmDelete',
    defaultMessage: 'Yes, Delete User',
  },
  deleteConfirmCancel: {
    id: 'app.containers.UserEdit.deleteConfirmCancel',
    defaultMessage: 'No, Keep User',
  },
  inviteUser: {
    id: 'app.containers.UserEdit.inviteUser',
    defaultMessage: 'Send Invitation',
  },
  inviteSuccess: {
    id: 'app.containers.UserEdit.inviteSuccess',
    defaultMessage: 'User has been successfully invited.',
  },
  inviteFailure: {
    id: 'app.containers.UserEdit.inviteFailure',
    defaultMessage: 'Error. The user could not be invited.',
  },
  deactivateUser: {
    id: 'app.containers.UserEdit.deactivateUser',
    defaultMessage: 'Deactivate User',
  },
  deactivateUserConfirmationText: {
    id: 'app.containers.UserEdit.deactivateUserConfirmationText',
    defaultMessage:
      'Deactivating the publisher will lead to him not being able to log into the system anymore.',
  },
  deactivateConfirmationButton: {
    id: 'app.containers.UserEdit.deactivateConfirmationButton',
    defaultMessage: 'Deactivate publisher',
  },
  deactivateConfirmationCancel: {
    id: 'app.containers.UserEdit.deactivateConfirmationCancel',
    defaultMessage: 'Keep publisher active',
  },
  deactivateSuccess: {
    id: 'app.containers.UserEdit.deactivateSuccess',
    defaultMessage: 'User has been successfully deactivated.',
  },
  deactivateFailure: {
    id: 'app.containers.UserEdit.deactivateFailure',
    defaultMessage: 'Error. The user could not be deactivated.',
  },
  lockUser: {
    id: 'app.containers.UserEdit.lockUser',
    defaultMessage: 'Lock User',
  },
  lockUserConfirmationText: {
    id: 'app.containers.UserEdit.lockUserConfirmationText',
    defaultMessage:
      'Locking the publisher will lead to him not being able to log into the system anymore.',
  },
  lockConfirmationButton: {
    id: 'app.containers.UserEdit.lockConfirmationButton',
    defaultMessage: 'Yes, lock publisher',
  },
  lockConfirmationCancel: {
    id: 'app.containers.UserEdit.lockConfirmationCancel',
    defaultMessage: 'Keep publisher unlocked',
  },
  lockSuccess: {
    id: 'app.containers.UserEdit.lockSuccess',
    defaultMessage: 'Publisher has been successfully locked.',
  },
  lockFailure: {
    id: 'app.containers.UserEdit.lockFailure',
    defaultMessage: 'Error. The publisher could not be locked.',
  },
  state: {
    id: 'app.containers.UserEdit.state',
    defaultMessage: 'User Status',
  },
  stateInactive: {
    id: 'app.containers.UserEdit.stateInactive',
    defaultMessage: 'This user is currently inactive and not able to log in.',
  },
  stateInvited: {
    id: 'app.containers.UserEdit.stateInvited',
    defaultMessage: 'This user got invited.',
  },
  stateActive: {
    id: 'app.containers.UserEdit.stateActive',
    defaultMessage: 'This user is activated and able to log in.',
  },
  stateLocked: {
    id: 'app.containers.UserEdit.stateLocked',
    defaultMessage: 'This user is locked and not able to log in.',
  },
  stateAtRiskToBecomeInactive: {
    id: 'app.containers.UserEdit.stateAtRiskToBecomeInactive',
    defaultMessage: 'This user is at risk to become inactive.',
  },
  impersonate: {
    id: 'app.containers.UserEdit.impersonate',
    defaultMessage: 'Impersonate',
  },
  delete: {
    id: 'app.containers.UserEdit.delete',
    defaultMessage: 'Delete',
  },
  auditLog: {
    id: 'app.containers.UserEdit.auditLog',
    defaultMessage: 'Audit log',
  },
  absences: {
    id: 'app.containers.UserEdit.absences',
    defaultMessage: 'Absences',
  },
  editProfile: {
    id: 'app.containers.UserEdit.editProfile',
    defaultMessage: 'Edit profile',
  },
});
